<template>
    <div>
        <div :id="barChartId" class="barChart">

        </div>
    </div>
</template>

<script>
    import {EleResize} from "@/utils/esresize.js";
    import store from '@/store/index.js';
    import {lang} from "@/utils/language.js";
    import echarts from 'echarts';

    export default {
        name: "BarChart",
        store,
        props: {
            bar_chart_data: {
                type: Object
            },
            changeCount: {
                type: Number,
                default: 0
            },
            allowDecimals:{
                type:Boolean,
                default: false
            },
            barChartStyle:{
                type:String,
                default:"V",
            }
        },
        data() {
            return {
                lang: lang,
                stateLang: '',
                barChartId:"barChart",
            }
        },
        mounted() {
            this.setChart();
        },
        methods: {
            drawBarChart(dom, option) {
                let myChart = echarts.init(document.getElementById(dom));
                let resizeDiv = document.getElementById(dom)
                //绘制图表
                myChart.setOption(option);
                let listener = function () {
                    myChart.resize()
                }
                EleResize.on(resizeDiv, listener)
            },
            setChart() {
                if("barChartId" in this.bar_chart_data){
                    this.barChartId = this.bar_chart_data.barChartId;
                }
                let dom = this.barChartId;

                // 竖版样式
                let optionV = {
                    color: ['#3398DB'],
                    title: {
                        text: this.bar_chart_data.title,
                        x: 'center'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        },
                        formatter: this.bar_chart_data.tooltipFormatter
                    },
                    grid: {
                        left: '8%',
                        right: '10%',
                        bottom: '3%',
                        containLabel: true
                    },
                    dataZoom: {
                        show: true,
                        realtime: true,
                        y: 36,
                        height: 20,
                        start: 0,
                        end: 80
                    },
                    xAxis: {
                        type: 'category',
                        data: this.bar_chart_data.xAxisArr,
                        axisLabel: {
                            interval: 0,//横轴信息全部显示
                            rotate: -20,// -20度角倾斜显示
                        },
                        axisTick: {
                            alignWithLabel: true
                        }
                    },
                    yAxis: {
                        allowDecimals: this.allowDecimals,
                        type: 'value',
                        axisLabel: {
                            show: true,
                            interval: 'auto',
                            formatter: this.bar_chart_data.yAxisFormatter
                        },
                    },
                    series: [{
                        name: "seriesName" in this.bar_chart_data?this.bar_chart_data.seriesName:this.lang("groupStatLookWordsChartSeriesName",this.language),
                        type: 'bar',
                        barWidth: '60%',
                        data: this.bar_chart_data.seriesData
                    }]
                }

                // 横版样式
                let optionH = {
                    color: ['#3398DB'],
                    title: {
                        text: this.bar_chart_data.title,
                        x: 'center'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        },
                        formatter: this.bar_chart_data.tooltipFormatter
                    },
                    grid: {
                        left: '8%',
                        right: '10%',
                        bottom: '3%',
                        containLabel: true
                    },
                    dataZoom: {
                        right: '93%',
                        type: 'slider',
                        show: true,
                        yAxisIndex: [0],
                        start: 0,
                        end: 80
                    },
                    xAxis: {
                        allowDecimals: this.allowDecimals,
                        type: 'value',
                        axisLabel: {
                            show: true,
                            interval: 'auto',
                            formatter: this.bar_chart_data.yAxisFormatter
                        },
                    },
                    yAxis: {
                        type: 'category',
                        data: this.bar_chart_data.xAxisArr,
                        axisLabel: {
                            interval: 0,//横轴信息全部显示
                            rotate: -0,// -20度角倾斜显示
                        },
                        axisTick: {
                            alignWithLabel: true
                        }
                    },
                    series: [{
                        name: "seriesName" in this.bar_chart_data?this.bar_chart_data.seriesName:"",
                        type: 'bar',
                        barWidth: '60%',
                        data: this.bar_chart_data.seriesData
                    }]
                }
                if(this.barChartStyle == "V"){
                    this.drawBarChart(dom, optionV)
                }else if(this.barChartStyle == "H"){
                    this.drawBarChart(dom, optionH)
                }
            },
        },
        computed: {
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            },

        },
        watch: {
            stateLang: function () {
                this.setChart();
            },
            changeCount: function () {
                this.setChart();
            }
        },

    }
</script>

<style scoped>
    .barChart {
        width: 100%;
        height: 500px;
    }
</style>
